import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import axios from 'axios';
import { getApiBaseUrl } from '../../utils/apiConfig';
import { getStorageValues } from '../CommonFunctions';

function DealerDropdown({ onChangeDropdown, required, showLabel = true, isDisabled, selectedValue }) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchDealers = async () => {
      try {
        const baseUrl = getApiBaseUrl();
        if (!baseUrl) {
          console.warn('DealerDropdown: API base URL missing, skipping fetch.');
          return;
        }
        const body = { UserId: getStorageValues('userId') };
        const response = await axios.post(`${baseUrl}/dealer/getall`, body);
        if (response.status === 200 && response.data?.data) {
          const dealerArray = response.data.data;
          const list = Array.isArray(dealerArray) && dealerArray.length > 0 && Array.isArray(dealerArray[0])
            ? dealerArray[0]
            : dealerArray;
          if (!Array.isArray(list)) {
            console.warn('DealerDropdown: Unexpected dealer payload format', response.data?.data);
            return;
          }
          const mapped = list.map((d) => ({
            value: d.DealerId?.toString(),
            label: d.DealerName || d.DealerCode || `Dealer ${d.DealerId}`,
            raw: d,
          }));
          setOptions(mapped);
          if (selectedValue) {
            const match = mapped.find((m) => m.value === selectedValue?.toString());
            setSelectedOption(match || null);
          }
        }
      } catch (err) {
        console.error('Failed to load dealers', err);
      }
    };
    fetchDealers();
  }, [selectedValue]);

  useEffect(() => {
    if (!selectedValue) {
      setSelectedOption(null);
      return;
    }
    const match = options.find((m) => m.value === selectedValue?.toString());
    setSelectedOption(match || null);
  }, [selectedValue, options]);

  const handleChange = (option, actionMeta) => {
    setSelectedOption(option);
    if (onChangeDropdown) {
      onChangeDropdown(option, actionMeta);
    }
  };

  return (
    <div>
      {showLabel && (
        <label className="form-label">
          Dealer {required ? <span style={{ color: 'red' }}>*</span> : null}
        </label>
      )}
      <Select
        name="DealerId"
        value={selectedOption}
        isClearable
        isDisabled={isDisabled}
        options={options}
        onChange={handleChange}
        placeholder="Select dealer"
        menuPlacement="auto"
        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      />
    </div>
  );
}

export default DealerDropdown;
